import React, { useState } from "react";
import SiteLayout from "@/components/SiteLayout";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <SiteLayout>
      <section className="mx-auto max-w-md px-6 py-16">
        <span className="overline">Account recovery</span>
        <h1 className="mt-2 font-display text-4xl font-bold text-[#0F2540]">Forgot your password?</h1>
        {!sent ? (
          <>
            <p className="mt-2 text-sm text-[#5C6B7A]">
              Enter the email you used to register. We'll send you a secure link to choose a new password.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-password-form">
              <div>
                <label className="text-sm font-medium text-[#0F2540]">Email</label>
                <input
                  type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus
                  className="mt-1 w-full rounded-xl border border-[#E1E8F0] bg-white px-4 py-2.5 outline-none focus:border-[#1E4F87]"
                  data-testid="forgot-email"
                />
              </div>
              <button disabled={loading || !email} className="btn-primary w-full justify-center" data-testid="forgot-submit">
                {loading ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        ) : (
          <div className="mt-6 rounded-2xl bg-[#F4F7FB] border border-[#E1E8F0] p-6" data-testid="forgot-success">
            <h2 className="font-display text-xl font-bold text-[#0F2540]">Check your email</h2>
            <p className="mt-2 text-sm text-[#0F2540]">
              If an account exists for <b>{email}</b>, we've sent a password-reset link to that address. The link expires in 30 minutes.
            </p>
            <p className="mt-3 text-xs text-[#5C6B7A]">
              Don't see it? Check your spam folder, or wait a couple of minutes and try again.
            </p>
          </div>
        )}
        <div className="mt-6 text-sm text-[#5C6B7A]">
          Remembered it? <Link to="/login" className="text-[#1E4F87] font-semibold">Back to sign in</Link>
        </div>
      </section>
    </SiteLayout>
  );
}
